let icons = [
	"/wp-content/themes/dlt/assets/images/about/icon_dlt.png",
	"/wp-content/themes/dlt/assets/images/about/icon_kabukiza.png"
]
let addresses = [];
let $html = document.documentElement;
export let gMap = {
	markers: [],
	init: function(){
		let $map = document.querySelectorAll(".gmap");
		for(let i = 0; i < $map.length; i++){
			let $m = $map[i];
			let address = $m.getAttribute("data-address");
			let arry = address.split(",");
			
			let ads = [Number(arry[0]), Number(arry[1])];
			addresses.push(ads);
		}
		gMap.makeMap();
	},
	makeMap: function(){
		let target = document.querySelector('#map_container');
		//歌舞伎座住所
		addresses.push([35.669643, 139.768074]);
		var options = {
			center: new google.maps.LatLng(addresses[0][0] + 0.0003, addresses[0][1]),
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			streetViewControl: false,
			scaleControl: false,
			zoomControl: true,
			overviewMapControl: false,
			mapTypeControl: false,
			panControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_RIGHT
			},
			mapTypeControlOptions: {
				position: google.maps.ControlPosition.TOP_CENTER
			},
			styles: [{"featureType": "all","elementType": "geometry","stylers": [{"color": "#212121"}]},{"featureType": "all","elementType": "geometry.stroke","stylers": [{"color": "#000000"}]},{"featureType": "all","elementType": "labels.text.fill","stylers": [{"color": "#757575"}]},{"featureType": "all","elementType": "labels.text.stroke","stylers": [{"color": "#000000"}]},{"featureType": "administrative","elementType": "geometry","stylers": [{"color": "#757575"}]},{"featureType": "administrative.locality","elementType": "geometry.stroke","stylers": [{"visibility": "on"}]},{"featureType": "administrative.locality","elementType": "labels","stylers": [{"visibility": "on"}]},{"featureType": "administrative.locality","elementType": "labels.text","stylers": [{"visibility": "on"},{"saturation": "-19"}]},{"featureType": "administrative.locality","elementType": "labels.text.fill","stylers": [{"color": "#cecece"},{"visibility": "on"}]},{"featureType": "administrative.neighborhood","elementType": "labels","stylers": [{"visibility": "on"}]},{"featureType": "administrative.neighborhood","elementType": "labels.text","stylers": [{"visibility": "on"}]},{"featureType": "landscape.man_made","elementType": "geometry.fill","stylers": [{"color": "#272727"},{"lightness": "1"},{"visibility": "on"}]},{"featureType": "landscape.man_made","elementType": "labels.text","stylers": [{"visibility": "off"}]},{"featureType": "poi","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "poi","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "poi","elementType": "labels.text","stylers": [{"visibility": "on"},{"lightness": "-14"},{"saturation": "-100"},{"gamma": "10.00"}]},{"featureType": "poi","elementType": "labels.text.fill","stylers": [{"gamma": "2.77"},{"lightness": "-3"}]},{"featureType": "poi","elementType": "labels.icon","stylers": [{"visibility": "off"},{"lightness": "-21"},{"saturation": "-100"},{"gamma": "1.09"}]},{"featureType": "poi.business","elementType": "labels.text.fill","stylers": [{"visibility": "on"},{"lightness": "-31"},{"gamma": "0.63"}]},{"featureType": "poi.business","elementType": "labels.icon","stylers": [{"saturation": "-100"},{"lightness": "39"},{"gamma": "0.27"}]},{"featureType": "road","elementType": "geometry.fill","stylers": [{"weight": 2},{"color": "#000000"}]},{"featureType": "road","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "road.highway","elementType": "geometry","stylers": [{"weight": 2}]},{"featureType": "road.highway","elementType": "geometry.stroke","stylers": [{"color": "#ffffff"}]},{"featureType": "road.highway","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "road.highway.controlled_access","elementType": "geometry.fill","stylers": [{"visibility": "on"},{"color": "#000000"}]},{"featureType": "road.arterial","elementType": "labels.text.fill","stylers": [{"visibility": "on"},{"color": "#ffffff"}]},{"featureType": "road.local","elementType": "geometry.fill","stylers": [{"color": "#000000"}]},{"featureType": "transit","elementType": "geometry.stroke","stylers": [{"color": "#ffffff"}]},{"featureType": "transit.station","elementType": "labels","stylers": [{"visibility": "on"},{"saturation": "-100"},{"lightness": "-3"},{"gamma": "0.86"}]},{"featureType": "transit.station","elementType": "labels.text.fill","stylers": [{"lightness": "89"},{"saturation": "-100"}]},{"featureType": "transit.station","elementType": "labels.icon","stylers": [{"visibility": "on"},{"saturation": "-100"},{"lightness": "-4"}]},{"featureType": "water","elementType": "geometry","stylers": [{"lightness": "33"}]
			}]
		};
		let map 	= new google.maps.Map(target, options);
		for(let j = 0; j < addresses.length; j++){
			let size;
			if(j === 0){
				if( $html.classList.contains("pc") ){
					size = new google.maps.Size(140, 117);
				}else{
					size = new google.maps.Size(70, 58);
				}
			}else{
				if( $html.classList.contains("pc") ){
					size = new google.maps.Size(120, 70);
				}else{
					size = new google.maps.Size(60, 35);
				}
			}
			console.log(icons[j]);
			let marker = new google.maps.Marker({
				map 		: map,
				position	: new google.maps.LatLng(addresses[j][0], addresses[j][1]),
				icon: {
					url: icons[j],
					scaledSize: size
				}
			});
			gMap.markers.push(marker);
		}
		//console.log(gMap.markers);
		initialize();
		
		/*
		let gmg = new google.maps.Geocoder(),map, center, mk;
		let latlng = "";
		let bounds = new google.maps.LatLngBounds();
		*/
		function initialize() {//初期化
			
		}
		
	}
}